<template>
  <div class="stuff-page">
    <div class="order_nav">
      <nav-bar
        @goBack="goBack"
        :bgTrans="true"
        :titleText="pageTitle"
        :lefticonshow="true"
        :TextColor="titStyle"
        :lefticon="lefticon"
        :righticonshow="true"
        :righticon="righticon"
        @rightclick="changeIcon"
      >
      </nav-bar>
    </div>
    <div class="stuff-List">
      <img
        src="@/assets/third/secondary/secondary_bg1.png"
        class="stuff_top"
        alt=""
      />
      <div class="stuff-box">
        <div class="stuff-box1">
          <van-pull-refresh
            v-model="isLoading"
            @refresh="onRefresh"
            v-if="goodsList"
          >
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="别拉了，小巴也是有底线的"
              @load="onLoad"
            >
              <van-row class="supermarket-like" v-if="!showVertical">
                <div
                  class="item-box"
                  v-for="(item, index) in goodsList"
                  :key="index"
                  @click.stop="goDetailBS(item.id)"
                >
                  <div class="item-img">
                    <img
                      class="imgPro"
                      :src="item.thumb"
                      @error="defaultPro()"
                    />
                    <img
                      src="@/assets/third/secondary/secondary_icon41x19.png"
                      alt=""
                    />
                  </div>
                  <div class="item-info">
                    <div class="name">
                      <img v-if="item.label" :src="item.label.image" alt="" />
                      {{ item.name }}
                    </div>
                    <div class="item-price">
                      <div class="i-price">
                        <span>¥{{ item.activity_min_price }}</span
                        ><s>¥{{ item.strikeout_price }}</s>
                      </div>
                      <div class="item-buyIt">立即抢购</div>
                    </div>
                  </div>
                </div>
              </van-row>
              <van-row class="supermarket-like item-vertical" v-else>
                <van-col span="12">
                  <div
                    class="item-box"
                    v-for="(item, index) in even(goodsList)"
                    :key="index"
                    @click.stop="goDetailBS(item.id)"
                  >
                    <div class="item-img">
                      <img
                        class="imgPro"
                        :src="item.thumb"
                        @error="defaultPro()"
                      />
                      <img
                        src="@/assets/third/secondary/secondary_icon41x19.png"
                        alt=""
                      />
                    </div>
                    <div class="item-info">
                      <div class="name">
                        <img v-if="item.label" :src="item.label.image" alt="" />
                        {{ item.name }}
                      </div>
                      <div class="item-price">
                        <div class="i-price">
                          <span>¥{{ item.activity_min_price }}</span
                          ><s>¥{{ item.strikeout_price }}</s>
                        </div>
                        <div class="item-buyIt">立即抢购</div>
                      </div>
                    </div>
                  </div>
                </van-col>
                <van-col span="12">
                  <div
                    class="item-box"
                    v-for="(item, index) in ogg(goodsList)"
                    :key="index"
                    @click.stop="goDetailBS(item.id)"
                  >
                    <div class="item-img">
                      <img
                        class="imgPro"
                        :src="item.thumb"
                        @error="defaultPro()"
                      />
                      <img
                        src="@/assets/third/secondary/secondary_icon41x19.png"
                        alt=""
                      />
                    </div>
                    <div class="item-info">
                      <div class="name">
                        <img v-if="item.label" :src="item.label.image" alt="" />
                        {{ item.name }}
                      </div>
                      <div class="item-price">
                        <div class="i-price">
                          <span>¥{{ item.activity_min_price }}</span
                          ><s>¥{{ item.strikeout_price }}</s>
                        </div>
                        <div class="item-buyIt">立即抢购</div>
                      </div>
                    </div>
                  </div>
                </van-col>
              </van-row>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import navBar from "../components/navBar";
export default {
  data() {
    return {
      crossicon: require("@/assets/third/secondary/cross_icon.png"),
      lefticon: require("@/assets/third/secondary/secondary_back1.png"),
      titleicon: require("@/assets/third/secondary/secondary_title1.png"),
      verticalIcon: require("@/assets/third/secondary/vertical_icon.png"),
      righticon: "",
      titStyle: "#fff",
      goodsList: [],
      goodsId: "",
      shopId: "",
      loading: false,
      finished: false,
      isLoading: false,
      page: 0,
      pageSize: 10,
      allList: 11,
      showVertical: false,
      sort_rule: "",
      area_id: "",
      pageTitle: "",
    };
  },
  components: {
    navBar,
  },
  created() {
    this.righticon = this.crossicon;
    let area_id = this.$route.query.id;
    let sort_rule = this.$route.query.sort_rule;
    this.pageTitle = this.$route.query.pageTitle;
    if (area_id) {
      this.area_id = area_id;
    }
    if (sort_rule) {
      this.sort_rule = sort_rule;
    }
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
    window.onresize = () => {
      document.documentElement.style.setProperty(
        "font-size",
        (document.body.clientWidth / 375) * 10 + "px"
      );
    };
  },
  methods: {
    even(list) {
      return list.filter((l, s) => {
        return s % 2 === 0;
      });
    },
    ogg(list) {
      return list.filter((l, s) => {
        return s % 2 != 0;
      });
    },
    goBack() {
      this.$router.go(-1);
    },
    changeIcon() {
      this.showVertical = !this.showVertical;
      this.righticon = this.showVertical ? this.verticalIcon : this.crossicon;
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getGoodsList();
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.goodsList = [];
      this.getGoodsList();
    },
    goDetailBS(id) {
      //商品详情
      let params = {
        goodsId: id,
        shopId: 8,
      };
      this.params(JSON.stringify(params), JSON.stringify(params), "goDetailBS");
    },
    getGoodsList() {
      this.$api
        .post("ongoods/index/goods/area-list", {
          area_id: this.area_id,
          sort_rule: this.sort_rule,
          page: this.page,
        })
        .then((res) => {
          this.allList = res.total;
          if (res.list.length > 0) {
            res.list.forEach((item, i) => {
              this.goodsList.push(item);
            });
          }
          this.loading = false;
          if (this.goodsList.length >= this.allList) {
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.stuff-page {
  min-height: 100%;
}
.order_nav {
  position: fixed;
  width: 100%;
  // z-index: 99999;
}
.stuff-List {
  min-height: 100%;
  .stuff-box {
    width: 100%;
    background: url("~@/assets/third/secondary/rectangle_icon.png") no-repeat;
    top: 8.5rem;
    background-size: 100%;
    position: fixed;
    height: calc(100% - 8.5rem);
    z-index: 99999999;
    .stuff-box1 {
      overflow-y: scroll;
      background: #fff;
      margin-top: 0.5rem;
      height: calc(100% - 0.5rem);
      border-radius: 2rem 2rem 0rem 0rem;
    }
  }
}
.stuff_top {
  z-index: 99999;
  width: 100%;
}
.supermarket-like {
  padding-top: 1rem;
}
.item-vertical {
  & > div:nth-of-type(2) > div {
    margin: 0 1rem 1rem 0.5rem;
  }
  .item-box {
    display: inline-block;
    width: 17.25rem;
    margin: 0 0.5rem 1rem 1rem;
    padding: 0;
    .item-info {
      .name {
        width: 100%;
        min-height: auto;
      }
      .item-buyIt {
        display: inline-block;
        width: 7rem;
        height: 2.5rem;
        background: #ff0113;
        border-radius: 1.5rem;
        text-align: center;
        font-size: 1.2rem;
        color: #fff;
        line-height: 2.5rem;
        transform: scale(0.8);
      }
    }
    .item-desc {
      display: flex;
      margin-top: 0;
    }
    .item-img {
      width: 17.25rem;
      height: 17.25rem;
      position: relative;
      border-radius: 0.6rem 0.6rem 0rem0rem;
      & > img:nth-of-type(1) {
        width: 100%;
        height: 100%;
      }
      & > img:nth-of-type(2) {
        position: absolute;
        top: 0;
        left: 0;
        width: 5.2rem;
        height: 2.4rem;
      }
    }
    .item-price {
      margin-top: 0.9rem;
    }
  }
  .i-price {
    flex: 1;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-items: center;
    overflow: hidden;
  }
}
.item-box {
  padding: 0 1rem 1.2rem 1rem;
  display: flex;
  .item-info {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    .name {
      width: 20.5rem;
      font-size: 1.4rem;
      font-weight: bold;
      color: #333333;
      padding: 0.4rem 0 0 0;
      max-height: 4rem;
      min-height: 4rem;
      line-height: 2rem;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      & > img {
        width: auto;
        height: 1.5rem;
        margin: 0 0.3rem 0 0;
        position: relative;
        display: inline-block;
        top: 0.3rem;
      }
    }
  }

  .type_icon1 {
    color: #fff;
    display: inline-block;
    background: linear-gradient(270deg, #fb7457 0%, #f14531 100%);
    border-radius: 0.2rem;
    font-size: 1rem;
    width: 2.6rem;
    height: 1.4rem;
    line-height: 1.4rem;
    // transform: scale(0.8);
    text-align: center;
    margin-right: 0.1rem;
  }
  .item-buyIt {
    display: inline-block;
    width: 8.2rem;
    height: 3rem;
    background: #ff0113;
    border-radius: 1.5rem;
    text-align: center;
    font-size: 1.2rem;
    color: #fff;
    line-height: 3rem;
  }
  .item-price {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.4rem;
  }
  .item-desc {
    flex: 1;
    display: flex;
    margin-top: 0.9rem;
    & > span {
      color: #fb5546;
      font-size: 1rem;
      // transform: scale(0.9);
    }
  }
  .i-price {
    & > span {
      color: #fa553d;
      font-size: 1.3rem;
      font-weight: bold;
    }
    & > s {
      color: #999999;
      font-size: 1.2rem;
      transform: scale(0.8);
      display: inline-block;
      margin-left: 0.2rem;
    }
  }
}
.item-img {
  width: 14rem;
  height: 14rem;
  margin-right: 1rem;
  position: relative;
  border-radius: 0.6rem;
  overflow: hidden;
  & > img:nth-of-type(1) {
    width: 100%;
    height: 100%;
  }
  & > img:nth-of-type(2) {
    position: absolute;
    top: 0;
    left: 0;
    width: 4.6rem;
    height: 2.1rem;
  }
}
</style>